import { useEffect, useState } from "react";
import { postData } from "../../ApiServices/ApiService";
import { ORG_LEAVE_REQUESTS_LIST } from "../../ApiServices/BaseURL";
import { logFrontendException } from "../../Utils/Exception";
import { useTheme } from "../../GlobalContext/GlobalContext";


const LeaveManagementController = () => {
    const { setIsLoginPopup } = useTheme();
    const [leaveRequestsList, setLeaveRequestsList] = useState([]);
    const [leaveRequestsLoading, setLeaveRequestsLoading] = useState(false);
    const [leaveRequestsError, setLeaveRequestsError] = useState('');

    const [leaveApprovalList, setLeaveApprovalList] = useState([]);
    const [leaveApprovalLoading, setLeaveApprovalLoading] = useState(false);
    const [leaveApprovalError, setLeaveApprovalError] = useState('');

    const pageName = 'LeaveManagementController';
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    useEffect(() => {
        fetchLeaveRequestsList();
        fetchLeaveApprovalList();
    }, [])

    const fetchLeaveRequestsList = async () => {
        try {
            setLeaveRequestsError('')
            //console.log('fetchTaskServicesSearchList')
            setLeaveRequestsLoading(true);
            setLeaveRequestsList([]);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "emp_id_auth": storedUserInfo?.emp_id,
                "action": "leave_request_list"
            }

            // Make the API call
            const response = await postData(ORG_LEAVE_REQUESTS_LIST, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setLeaveRequestsList(responseData?.dataJ);
                        } else {
                            setLeaveRequestsError(responseData?.info || 'No leave requests available.');
                            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                            logFrontendException(storedUserId, pageName, "fetchLeaveRequestsList", responseData?.info || '');
                        }
                    } else {
                        setLeaveRequestsError(responseData?.info || 'Failed to fetch leave requests. Please try again.');
                        logFrontendException(storedUserId, pageName, "fetchLeaveRequestsList", responseData?.info || '');
                    }
                } else {
                    setLeaveRequestsError(responseData?.info || 'Failed to fetch leave requests.');
                    logFrontendException(storedUserId, pageName, "fetchLeaveRequestsList", responseData || '');
                }
            }       // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
              setLeaveRequestsError('Unauthorized access. Your session may have expired. Please log in again.');
              logFrontendException(storedUserId, pageName, "fetchLeaveRequestsList", responseData || '');
              setIsLoginPopup(true)
            } else {
                setLeaveRequestsError('Error while fetching leave requests.');
                logFrontendException(storedUserId, pageName, "fetchLeaveRequestsList", response || '');
            }
        } catch (error) {
            setLeaveRequestsError(`Failed to fetch leave requests. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "fetchLeaveRequestsListCatch", error || '');
        } finally {
            setLeaveRequestsLoading(false);
        }
    }


    const fetchLeaveApprovalList = async () => {
        try {
            setLeaveApprovalError('')
            setLeaveApprovalLoading(true);
            setLeaveApprovalList([]);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "emp_id_auth": storedUserInfo?.emp_id,
                "action": "leave_approval_list"
            }
            // Make the API call
            const response = await postData(ORG_LEAVE_REQUESTS_LIST, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setLeaveApprovalList(responseData?.dataJ);
                        } else {
                            setLeaveApprovalError(responseData?.info || 'No leave approvals available.');
                            // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                            logFrontendException(storedUserId, pageName, "fetchLeaveApprovalList", responseData?.info || '');
                        }
                    } else {
                        setLeaveApprovalError(responseData?.info || 'Failed to fetch leave approvals. Please try again.');
                        logFrontendException(storedUserId, pageName, "fetchLeaveApprovalList", responseData?.info || '');
                    }
                } else {
                    setLeaveApprovalError(responseData?.info || 'Failed to fetch leave approvals.');
                    logFrontendException(storedUserId, pageName, "fetchLeaveApprovalList", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setLeaveApprovalError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserId, pageName, "fetchLeaveApprovalList", responseData || '');
                setIsLoginPopup(true)
            } else {
                setLeaveApprovalError('Error while fetching leave approvals.');
                logFrontendException(storedUserId, pageName, "fetchLeaveApprovalList", response || '');
            }
        } catch (error) {
            setLeaveApprovalError(`Failed to fetch leave approvals. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "fetchLeaveApprovalListCatch", error || '');
        } finally {
            setLeaveApprovalLoading(false);
        }
    }

    const leaveRequestRefresh = () => {
        console.log('leaveRequestRefresh')
        fetchLeaveRequestsList();
        fetchLeaveApprovalList();
    }

    const leaveApprovalRefresh = () => {
        console.log('leaveApprovalRefresh')
        fetchLeaveRequestsList();
        fetchLeaveApprovalList();
    }


    return {
        leaveRequestsList, leaveRequestsLoading, leaveRequestsError,
        leaveApprovalList, leaveApprovalLoading, leaveApprovalError,
        leaveRequestRefresh, leaveApprovalRefresh
    }

}
export default LeaveManagementController;